/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import {
  LOAD_VENDOR_RECORDS_META_DATA,
  LOAD_VENDOR,
  CREATE_VENDOR,
  UPDATE_VENDOR,
  DELETE_VENDOR,
  LOAD_VENDOR_COLLECT,
  LOAD_VENDOR_PAY,
  LOAD_VENDOR_TRANSACTION,
  LOAD_VENDOR_CATEGORY,
  CREATE_VENDOR_CATEGORY,
} from "./constants";

import {
  loadVendorError,
  loadVendor,
  loadVendorSuccess,
  createVendorListSuccess,
  createVendorListError,
  updateVendorListSuccess,
  updateVendorListError,
  deleteVendorListSuccess,
  deleteVendorListError,
  loadVendorRecordsMetaDataError,
  loadVendorRecordsMetaDataSuccess,
  loadVendorCollect,
  loadVendorCategory,
  loadVendorCategorySuccess,
  loadVendorCategoryError,
  createVendorCategoryListSuccess,
  createVendorCategoryListError,
  loadVendorCollectSuccess,
  loadVendorCollectError,
  loadVendorPay,
  loadVendorPaySuccess,
  loadVendorPayError,
  loadVendorTransaction,
  loadVendorTransactionSuccess,
  loadVendorTransactionError,
} from "./actions";

import {
  loadVendorDetails,
  createVendorDetails,
  updateVendorDetails,
  deleteVendorDetails,
  loadRecordsMetaData,
  loadVendorCollectDetails,
  loadVendorPayDetails,
  loadVendorTransactionDetails,
  loadVendorCategoryDetails,
  createVendorCategoryDetails,
} from "./remotes";

function* loadVendorSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_VENDOR),
    });

    const { explicitLoad } = load;
    const { vendorList } = explicitLoad || {};
    yield put(loadVendor(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadVendorDetails, vendorList);

        if (result) {
          yield put(loadVendorSuccess(result));
        }
      } catch (error) {
        yield put(
          loadVendorError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* loadVendorCollectSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_VENDOR_COLLECT),
    });

    const { explicitLoad } = load;
    const { vendorList } = explicitLoad || {};
    yield put(loadVendorCollect(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadVendorCollectDetails, vendorList);

        if (result) {
          yield put(loadVendorCollectSuccess(result));
        }
      } catch (error) {
        yield put(
          loadVendorCollectError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadVendorPaySaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_VENDOR_PAY),
    });

    const { explicitLoad } = load;
    const { vendorList } = explicitLoad || {};
    yield put(loadVendorPay(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadVendorPayDetails, vendorList);

        if (result) {
          yield put(loadVendorPaySuccess(result));
        }
      } catch (error) {
        yield put(
          loadVendorPayError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadVendorTransactionSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_VENDOR_TRANSACTION),
    });

    const { explicitLoad } = load;
    const { vendorList } = explicitLoad || {};
    yield put(loadVendorTransaction(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadVendorTransactionDetails, vendorList);

        if (result) {
          yield put(loadVendorTransactionSuccess(result));
        }
      } catch (error) {
        yield put(
          loadVendorTransactionError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadVendorCategorySaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_VENDOR_CATEGORY),
    });
    const { explicitLoad } = load;
    const { categoryList } = explicitLoad || {};
    yield put(loadVendorCategory(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadVendorCategoryDetails, categoryList);

        if (result) {
          yield put(loadVendorCategorySuccess(result));
        }
      } catch (error) {
        yield put(
          loadVendorCategoryError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createVendorCategorySaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_VENDOR_CATEGORY),
    });
    const { categoryList } = create || {};

    if (create) {
      try {
        const result = yield call(createVendorCategoryDetails, categoryList);
        if (result) {
          yield put(createVendorCategoryListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createVendorCategoryListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createVendorSaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_VENDOR),
    });

    const { vendorList } = create || {};

    if (create) {
      try {
        const result = yield call(createVendorDetails, vendorList);
        if (result) {
          yield put(createVendorListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createVendorListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* updateVendorSaga() {
  while (true) {
    const { update } = yield race({
      update: take(UPDATE_VENDOR),
    });
    const { vendorList } = update || {};

    if (update) {
      try {
        const result = yield call(updateVendorDetails, vendorList);
        if (result) {
          yield put(updateVendorListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          updateVendorListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* deleteVendorSaga() {
  while (true) {
    const { create } = yield race({
      create: take(DELETE_VENDOR),
    });
    const { vendorList } = create || {};

    if (create) {
      try {
        const result = yield call(deleteVendorDetails, vendorList);
        if (result) {
          yield put(deleteVendorListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          deleteVendorListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadVendorRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_VENDOR_RECORDS_META_DATA),
    });

    try {
      const gstPercentage = yield call(loadRecordsMetaData, "getgst", "post");
      const state = yield call(loadRecordsMetaData, "getstate", "post");
      const currency = yield call(loadRecordsMetaData, "getcurrency", "post");

      let recordsMetaData = {
        gstPercentageOptions:
          (gstPercentage &&
            gstPercentage &&
            gstPercentage.length > 0 &&
            gstPercentage.map((c) =>
              Object.assign(
                {},
                {
                  label: c.gstpercentageName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
        stateOptions:
          (state &&
            state &&
            state.length > 0 &&
            state.map((c) =>
              Object.assign(
                {},
                {
                  label: c.stateName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
        currencyOptions:
          (currency &&
            currency &&
            currency.length > 0 &&
            currency.map((c) =>
              Object.assign(
                {},
                {
                  label: c.currencyName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
      };

      yield put(loadVendorRecordsMetaDataSuccess(recordsMetaData));
    } catch (error) {
      yield put(
        loadVendorRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      );
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadVendorSaga(),
    loadVendorCollectSaga(),
    loadVendorPaySaga(),
    deleteVendorSaga(),
    updateVendorSaga(),
    createVendorSaga(),
    loadVendorRecordsMetaDataSaga(),
    loadVendorTransactionSaga(),
    createVendorCategorySaga(),
    loadVendorCategorySaga(),
  ]);
}
